module.exports = __webpack_public_path__ + "static/media/29ADMSPC29.cdfa7948.jpg";